import { RouterProvider, createMemoryRouter, type RouteObject } from "react-router-dom";
import { SplitScreenProvider } from "./split-screen-context";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "@/store";
import { SplitErrorBoundary } from "./split-error-boundary";
import { SplitPanelEmptyState } from "./split-panel-empty-state";
import { useMemo } from "react";
import { SplitModuleWrapper } from "./split-module-wrapper";
import CompanyDashboard from "@/pages/(home)/(company)/dashboard";
import Dashboard from "@/pages/(home)/(my-space)/dashboard";

interface Props {
  routes: RouteObject[];
  initialPath: string;
}

export const SplitBottomPanelApp = ({ routes, initialPath }: Props) => {
  const splitRouter = useMemo(() => {
    return createMemoryRouter(
      [
        {
          element: <SplitModuleWrapper />,
          children: [
            {
              index: true,
              element: <Dashboard />,
            },
            ...routes,
            {
              path: "company",
              children: [
                {
                  index: true,
                  element: <CompanyDashboard />,
                },
              ],
            },

            {
              path: "*",
              element: <SplitPanelEmptyState moduleNotFound />,
            },
          ],
        },
      ],
      {
        initialEntries: [initialPath],
      },
    );
  }, [routes, initialPath]);

  return (
    <ReduxProvider store={store}>
      <SplitScreenProvider>
        <SplitErrorBoundary>
          <RouterProvider router={splitRouter} />
        </SplitErrorBoundary>
      </SplitScreenProvider>
    </ReduxProvider>
  );
};
